import React from 'react';

const MainHeader = ({ onFilterChange, selectedFilters, selectedSection }) => {
    return (
        <div className="header-styling">
            <div className="main-title">{selectedSection}</div>
            <div className="main-buttons-container">
                <button
                    className={`filter-button res-filter ${selectedFilters.includes('Resource') ? 'selected' : ''}`}
                    onClick={() => onFilterChange('Resource')}>
                    Resources
                </button>
                <button
                    className={`filter-button prog-filter ${selectedFilters.includes('Program') ? 'selected' : ''}`}
                    onClick={() => onFilterChange('Program')}>
                    Programs
                </button>
            </div>
        </div>
    );
};

export default MainHeader;
